import * as t from 'io-ts'

import * as tv from '@espoon-voltti/ts-libs/lib/io-ts-types'

import { AttachmentMetadata } from '@espoon-voltti/react-voltti/components/attachment-selector/domain/model'

export interface Report {
  attachments: AttachmentMetadata[]
}

export const ApprovedPreReportDecision = t.type(
  {
    decision: t.literal('APPROVED'),
    amountInCents: tv.euroCentsFromNumber
  },
  'ApprovedPreReportDecision'
)
export type ApprovedPreReportDecision = t.TypeOf<
  typeof ApprovedPreReportDecision
>

export const RejectedPreReportDecision = t.type(
  {
    decision: t.literal('REJECTED')
  },
  'RejectedPreReportDecision'
)
export type RejectedPreReportDecision = t.TypeOf<
  typeof RejectedPreReportDecision
>

export const ApprovedPostReportDecision = t.type(
  {
    decision: t.literal('APPROVED')
  },
  'ApprovedPreReportDecision'
)
export type ApprovedPostReportDecision = t.TypeOf<
  typeof ApprovedPostReportDecision
>

export const RejectedPostReportDecision = t.type(
  {
    decision: t.literal('REJECTED'),
    amountInCents: tv.euroCentsFromNumber,
    dueDate: tv.localDateFromString
  },
  'RejectedPreReportDecision'
)
export type RejectedPostReportDecision = t.TypeOf<
  typeof RejectedPostReportDecision
>
